import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import Box from '@components/layout/box';
import Flex from '@components/layout/flex';
import EarningsIndicator from '@components/dashboard/metrics-widget/earnings-indicator';
import EarningsPercentageIndicator from '@components/dashboard/metrics-widget/earnings-percentage-indicator';

interface SidebarEarningsBoxProps {
  className?: string;
  earned: Dinero.Dinero;
  thisMonthEarned: Dinero.Dinero;
  streamingPercenatge: number;
  merchPercentage: number;
  publishingPercentage: number;
}

const SidebarEarningsBox: FunctionComponent<SidebarEarningsBoxProps> = ({
  className,
  earned,
  thisMonthEarned,
  streamingPercenatge,
  merchPercentage,
  publishingPercentage,
}) => {
  return (
    <Box className={className || ''}>
      <Flex flexDirection="column" gap={20}>
        <Flex className="title-box" alignItems="center" gap={25}>
          <EarningsIndicator
            refText="DASHBOARD.NEW_DASHBOARD.METRICS.EARNINGS.TOTAL"
            textTop={false}
            label={earned}
          />
          <EarningsIndicator
            refText="DASHBOARD.NEW_DASHBOARD.METRICS.EARNINGS.THIS_PERIOD"
            textTop={false}
            label={thisMonthEarned}
          />
        </Flex>
        <Flex alignItems="center" gap={90}>
          <EarningsPercentageIndicator
            refText="EARNINGS.LIST.MUSIC.TITLE"
            textTop={false}
            label={streamingPercenatge}
          />
          <EarningsPercentageIndicator
            refText="EARNINGS.LIST.MERCH.TITLE"
            textTop={false}
            label={merchPercentage}
          />
          <EarningsPercentageIndicator
            refText="EARNINGS.LIST.PUBLISHING.TITLE"
            textTop={false}
            label={publishingPercentage}
          />
        </Flex>
      </Flex>
    </Box>
  );
};

export default styled(SidebarEarningsBox)`
  height: fit-content;
  padding: 32px;

  .title-box {
    margin-bottom: 5px;
  }

  .stakeholder-text {
    color: ${({ theme }) => theme.colors.tertiary};
  }
`;
